import { render, staticRenderFns } from "./AreaLimit.vue?vue&type=template&id=6f4530ba&scoped=true&"
import script from "./AreaLimit.vue?vue&type=script&lang=js&"
export * from "./AreaLimit.vue?vue&type=script&lang=js&"
import style0 from "./AreaLimit.vue?vue&type=style&index=0&id=6f4530ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4530ba",
  null
  
)

export default component.exports